import { Box, Typography } from "@mui/material";

export default function UsersCounter({ value }) {
  return (
    <Box display="flex">
      <Typography mr={0.5}>{value}</Typography>
      <Typography>Users</Typography>
    </Box>
  );
}
